import moment from "moment";
import {
	mapState
} from "vuex";
import defaultMixin from "./default";
import validation from "@/scripts/_validation";
export default {
	mixins: [defaultMixin],
	computed: {
		...mapState({
			Reservation: "reservation",
			Channel: "channel",
			Registration: "registration",
			Profile: "profile"
		}),
		isMobile() {
			return new RegExp("Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Minii", "i").test(navigator.userAgent)
		},
		selectedProducts() {
			return validation.getSelectedProducts(this.Reservation);
		},
		selectedTimeFrame() {
			if (!this.Reservation.From.TimeFrame) return null;
			let timeFrame = this.asTimeFrameViewModel(this.Reservation.From.TimeFrame);
			return timeFrame;
		},
		totalSum() {
			return this.selectedProducts
				.map(c => c.Tariffs)
				.flat()
				.reduce((acc, curr) => acc + (curr.Count * curr.Total), 0);
		},
		logoWidth() {
			return this.Channel.Theme.Widths && this.Channel.Theme.Widths.Logo ? `width: ${this.Channel.Theme.Widths.Logo}` : "width: 200px";
		},
		hub() {
			return this.$root.hub;
		}
	},
	methods: {
		isRestrictionOverPassed(key) {
			return this.Channel.Admin &&
				this.Channel.Admin.IsActive &&
				this.Channel.Admin.OverPassedRestrictions &&
				this.Channel.Admin.OverPassedRestrictions.indexOf(key) > -1
		},
		asTimeFrameViewModel(timeFrame, isSelected, totalCount) {
			let start = moment(timeFrame.From).format("HH:mm");
			let end = moment(timeFrame.Until).format("HH:mm");
			let vm = {
				position: timeFrame.Times.Start,
				text: totalCount > 3 ? start + "-" + end + " " + this.T("o_clock") : this.T(timeFrame.Name),
				subText: totalCount > 3 ? null : start + "-" + end + " " + this.T("o_clock"),
				value: timeFrame._uuid,
				isSelected: isSelected
			};

			//
			vm.fullText = totalCount <= 3 ? `<span class="normal">${vm.text}</span><br /><span class="small">${vm.subText}</span>` : vm.text;
			return vm;
		},
		formatDate(date, startTime, endTime) {
			let txt = moment(date).format("dddd DD.MM.YYYY");
			if (startTime && endTime) txt += ", " + moment().startOf("day").add(startTime, "minutes").format("HH:mm") + "-" + moment().startOf("day").add(endTime, "minutes").format("HH:mm") + " " + this.T("o_clock");
			else if (startTime) txt += ", " + moment().startOf("day").add(startTime, "minutes").format("HH:mm") + " " + this.T("o_clock");
			return txt;
		},
		formatRange(start, end) {
			const startDate = moment(start);
			const endDate = moment(end);
			if (startDate.isSame(endDate, "day")) {
				return startDate.format("dddd DD.MM.YYYY") + ", " + startDate.format("HH:mm") + "-" + endDate.format("HH:mm");
			}

			return startDate.format("DD.MM.YYYY") + " - " + endDate.format("DD.MM.YYYY");
		},
		tryFormatRange(start, end) {
			try {
				return this.formatRange(start, end);
			} catch (err) {
				return null;
			}
		},
		formatPrice(p, channel) {
			return p === 0 && channel && channel.Type === 'Services' ? this.T("free_entrance_services") : p === 0 ? this.T("free_entrance") : p.toFixed(2) + " EUR";
		},
		getTimeFromMinutes(minutes, defaultUnit = "minutes") {
			if (minutes == null) return {
				value: null,
				unit: defaultUnit
			};

			// 
			let value = null,
				unit = defaultUnit;

			if (minutes % 60 !== 0 || minutes === 0) {
				value = minutes;
				unit = "minutes";
			} else if (minutes % (60 * 24) === 0) {
				value = minutes / 60 / 24;
				unit = "days";
			} else {
				value = minutes / 60;
				unit = "hours";
			}

			return {
				value: value,
				unit: unit
			};
		},
		getTimeStringFromMinutes(minutes) {
			var parsed = this.getTimeFromMinutes(minutes);
			switch (parsed.unit) {
				case "minutes":
					return `${parsed.value} ${this.T("minutes")}`;
				case "hours":
					return `${parsed.value} ${this.T("hours")}`;
				default:
					return `${parsed.value} ${this.T("days")}`;
			}
		},
	},
}